














































































































































































import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'
import { OrderDetailAction } from '../../marketplace-model'
import { generateSpecifications } from '@/components/order-specifications'
import VehicleTypes from '@/components/new-design/order-common/VehicleTypes.vue'
import MultiStopStepper from './multi-stop-stepper/MultiStopStepper.vue'
import { fetchOrderStops } from '@/services/ordering-service'
import {
  generateRequirementsList,
  generateFormattedRequirements
} from '@/components/order-requirements'
import { LoadSpecifications } from '@/services/models/marketplace-service-model'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import OrdersPagination from '@/components/OrdersPagination.vue'
import isEmpty from 'lodash/isEmpty'

const MAX_CHARS_PER_LINE = 120

export default {
  components: {
    MultiStopStepper,
    LoadingSpinner,
    VehicleTypes,
    OrdersPagination
  },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    nextLoadSuggestions: { type: Array, required: false, default: () => [] },
    isNextLoadSuggestion: { type: Boolean, required: false, default: false },
    carrierId: { type: Number, required: true },
    selectedOrder: {
      type: Object,
      required: true,
      default: () => ({
        order: {},
        multiStop: {},
        companyTransportRequests: []
      })
    }
  },
  data() {
    return {
      stops: [],
      isMapReady: false,
      routeNotAvailable: false,
      origin: {},
      destination: {},
      waypoints: [],
      stopsLimitReached: false,
      isRoundTrip: false,
      loadSpecifications: null as LoadSpecifications,
      loadSpecificationFields: ['weight', 'dimensions', 'palletInformation']
    }
  },
  computed: {
    loadSpecTooltip() {
      if (!this.selectedOrder.order) return
      return (
        this.formattedLoadDescription.length > MAX_CHARS_PER_LINE &&
        this.formattedLoadDescription
      )
    },
    loadRequirementsTooltip() {
      if (!this.selectedOrder.order) return
      return (
        this.formattedRequirements.length > MAX_CHARS_PER_LINE &&
        this.formattedRequirements
      )
    },
    suggestedBaseCost(): number {
      return this.selectedOrder.order?.suggestedBaseCost || 0
    },
    stopLocations() {
      if (this.stops.length < 10) {
        return this.stops.map((stop, index) => ({
          id: index,
          lat: stop.warehouseAddress.latitude,
          lng: stop.warehouseAddress.longitude,
          address: stop.warehouseAddress.fullAddress
        }))
      }
      return []
    },
    formattedRequirements() {
      const requirements = generateRequirementsList(this.selectedOrder.order)
      return this.generateFormattedRequirements(requirements, true).join(' | ')
    },
    orderIdForStaff() {
      if (!this.selectedOrder.order) return ''
      return `${this.$t('marketPlace.order')} ${this.selectedOrder.order.idForStaff}`
    },
    formattedLoadDescription() {
      return (this.selectedOrder.order && this.selectedOrder.order.loadDescription) || '-'
    },
    nextLoadSuggestionIds(): Array<number> {
      return this.nextLoadSuggestions.map(item => item.order.id)
    },
    selectedOrderIndex(): number {
      return this.nextLoadSuggestions.findIndex(item => item === this.selectedOrder)
    }
  },
  watch: {
    selectedOrder(value) {
      if (!isEmpty(value)) {
        this.isMapReady = false
        this.stops = []
        this.onShown()
      }
    }
  },
  methods: {
    generateFormattedRequirements,
    close() {
      this.stopsLimitReached = false
      this.$emit('close')
    },
    onRouteNotAvailable(event) {
      this.routeNotAvailable = event
    },
    async onShown() {
      this.stops = await this.getOrderStops(this.selectedOrder.order.id)
      this.calculateOriginAndDestination(this.stops)
      this.isTripRoundTrip(this.stops)
      this.computeLoadSpecifications()
    },
    handleRequestOffer() {
      trackEvent(SEGMENT_EVENTS.ODV_REQUEST_OFFER_TRIGGERED, {
        carrierId: this.carrierId,
        orderId: this.selectedOrderId
      })

      this.$emit('close', OrderDetailAction.PlaceRequest)
    },
    handleAcceptNow() {
      trackEvent(SEGMENT_EVENTS.ODV_ACCEPT_NOW_TRIGGERED, {
        orderId: this.selectedOrderId
      })

      this.$emit('close', OrderDetailAction.AcceptNow)
    },
    isTripRoundTrip() {
      const origin = this.stops[0]?.warehouseAddress.fullAddress
      const destination = this.stops[this.stops.length - 1]?.warehouseAddress.fullAddress
      this.isRoundTrip = origin === destination
    },
    calculateOriginAndDestination(routes) {
      if (routes.length < 10) {
        const lastIndex = routes.length - 1
        this.origin = routes[0]?.warehouseAddress
        this.destination = routes[lastIndex]?.warehouseAddress
        this.waypoints = this.createWaypointsArray(routes)
        this.isMapReady = true
        return
      }
      this.handleFallback()
    },
    handleFallback() {
      this.isMapReady = true
      this.routeNotAvailable = true
      this.stopsLimitReached = true
      trackEvent(SEGMENT_EVENTS.ODV_MULTI_STOPS_LIMIT_REACHED, {
        carrierId: this.carrierId,
        orderId: this.selectedOrder.order.id
      })
    },
    createWaypointsArray(stops) {
      if (stops.length > 2) {
        return stops
          .filter((stop, index) => index > 0 && index < stops.length - 1)
          .map(stop => ({
            location: {
              longitude: stop.warehouseAddress.longitude,
              latitude: stop.warehouseAddress.latitude
            }
          }))
      }
    },
    async getOrderStops(orderId) {
      return await fetchOrderStops(orderId)
    },
    updateSuggestedLoad(orderId) {
      this.$emit('updateSuggestedLoad', orderId)
    },
    computeLoadSpecifications() {
      this.loadSpecifications = generateSpecifications(this.selectedOrder.order || {})
    }
  }
}
